import InvestorLogin from '@/dealroadshow/ui/components/Landing/Institutional/InvestorLogin';
import LandingLayout from '@drs/ui/Landing/Layout/LandingLayout';
import InvestorAutologin from '@/dealroadshow/ui/components/Landing/Institutional/InvestorAutologin';
import withApplicationProps from '@/dealroadshow/application/withApplicationProps';

export const getServerSideProps = withApplicationProps(() => ({ props: {} }));

export default () => (
  <InvestorAutologin>
    <LandingLayout>
      <InvestorLogin />
    </LandingLayout>
  </InvestorAutologin>
);
